export const getCompanyDashboardAnalyticsQuery = `
  query GetCompanyDashboardAnalytics($input: CompanyAnalyticsInput) {
    getCompanyDashboardAnalytics(input: $input) {
      code
      subscriptionAnalytics {
        subscriptionStatus
        lastPaymentAmount
        nextBillingAt
      }
      employeeAnalytics {
        totalEmployees
        activeEmployees
        recentLoginsInPeriod
        employeesByStatus { key value }
        employeesByRole { key value }
      }
      storeAnalytics {
        totalStores
        activeStores
        storesByStatus { key value }
      }
      supplierAnalytics {
        totalSuppliers
        activeSuppliers
        suppliersByStatus { key value }
      }
      customerAnalytics {
        totalCustomers
        newCustomersInPeriod
        activeCustomersInPeriod
        repeatCustomers
        averageOrdersPerCustomer
        customersWithOutstandingInvoices
        customersByType { key value }
        totalOutstandingByCustomer { key value }
      }
      productAnalytics {
        totalProducts
        activeProducts
        totalProductItems
        inStockProductItems
        totalCategories
        activeCategories
        productsByStatus { key value }
        productItemsByState { key value }
        categoriesByStatus { key value }
      }
      orderAnalytics {
        totalOrders
        totalRevenue
        revenueInPeriod
        vatToPay
        totalInvoices
        completedOrdersInPeriod
        orderCountInPeriod
        ordersByStatus { key value }
        invoicesByStatus { key value }
      }
      salesInventoryTrend {
        date
        sales
        inventory
      }
    }
  }
`;
